export default "/_next/static/images/99a6cc2a11fcb7fa69390a829413b862.svg";